<template>
  <div
    class="stock-line-field"
    :class="{
      'stock-line-field--narrow': narrow,
      'stock-line-field--alloc': alloc,
    }"
  >
    <DatePicker
      v-if="isDateField"
      :value="value"
      v-bind="fieldAttrs"
      without-icon
      without-hint
      solo
      dense
      hide-details
      class="stock-line-field__input"
      v-on="listenersWithoutInput"
      @input="$emit('input', $event)"
    />
    <v-text-field
      v-else
      v-bind="$attrs"
      :value="value"
      :error="error"
      solo
      dense
      hide-details
      class="stock-line-field__input"
      v-on="$listeners"
    />
    <div
      v-if="hint"
      class="stock-line-field__hint text-caption text-center text-truncate"
      :class="hintClass"
      :title="hint"
    >
      {{ hint }}
    </div>
  </div>
</template>

<script>
import DatePicker from "@/views/partials/form/DatePicker.vue";

export default {
  name: "StockLineField",
  components: { DatePicker },
  inheritAttrs: false,
  props: {
    value: { default: null },
    hint: { type: String, default: "" },
    narrow: { type: Boolean, default: false },
    alloc: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },
  computed: {
    hintClass() {
      return this.error ? "stock-line-field__hint--error" : "grey--text";
    },
    isDateField() {
      return this.$attrs.type === "date";
    },
    fieldAttrs() {
      const { type, ...rest } = this.$attrs;
      return rest;
    },
    listenersWithoutInput() {
      const { input, ...rest } = this.$listeners;
      return rest;
    },
  },
};
</script>

<style scoped>
.stock-line-field__hint {
  line-height: 1.15;
  margin-top: 2px;
  min-height: 14px;
  padding: 0 2px;
}

.stock-line-field__hint--error {
  color: #f44336;
  font-weight: 500;
}
</style>
